import { ViewportScroller } from '@angular/common'
import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { DeliveryMode } from '@spartacus/cart/base/root'
import { CheckoutDeliveryModesService } from '@spartacus/checkout/base/core'
import { OrderDetailActionsComponent, OrderDetailsService } from '@spartacus/order/components'
import { OrderActions } from '@spartacus/order/core'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {EbOrderHistoryService} from "../../services/facades/eb-order-history.service";

@Component({
    selector: 'eb-order-detail-overview',
    templateUrl: './eb-order-detail-overview.component.html',
    styleUrls: ['./eb-order-detail-overview.component.scss'],
    standalone: false
})
export class EbOrderDetailOverviewComponent extends OrderDetailActionsComponent {
  constructor(
    protected ebCheckoutDeliveryService: CheckoutDeliveryModesService,
    protected orderDetailsService: OrderDetailsService,
    protected ebOrderHistoryService: EbOrderHistoryService,
    protected store: Store,
    private viewportScroller: ViewportScroller
  ) {
    super(orderDetailsService)
  }

  order$: Observable<any> = this.ebOrderHistoryService.getOrderDetails();

  ngOnDestroy() {
    this.store.dispatch(new OrderActions.ClearOrderDetails())
  }

  get deliveryAvailableModes$(): Observable<DeliveryMode[]> {
    return this.ebCheckoutDeliveryService.getSupportedDeliveryModes()
  }

  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId)
  }

  get currentDeliveryMode$(): Observable<DeliveryMode> {
    return combineLatest([this.deliveryAvailableModes$, this.order$]).pipe(
      map(([deliveryModes, order]) => {
        return deliveryModes.filter(mode => mode.code === order.shippingType)[0]
      })
    )
  }
}
